function Footer() {
    const scrollToSection = (sectionId) => {
        const element = document.querySelector(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <div className="footer-logo">
                            <img src="/assets/img/logo-light.svg" alt=" " style={{width: '60px', height: '60px'}} />
                        </div>
                        <p className="footer-description">
                            Alpha Cogs pioneers Emotional Intelligence Engine (EIE) technology, 
                            transforming how businesses understand and respond to human emotions 
                            through real-time AI-powered emotional intelligence.
                        </p>
                        <div className="footer-social">
                            <a href="https://www.linkedin.com/company/alpha-cogs" target="_blank" rel="noopener noreferrer" className="social-link">in</a>
                        </div>
                    </div>
                    
                    <div className="footer-links">
                        <div className="footer-column">
                            <h4>Navigation</h4>
                            <ul>
                                <li><a href="#hero" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Home</a></li>
                                <li><a href="#demo" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-use-cases'); }}>How It Works</a></li>
                                <li><a href="#industries" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-industries'); }}>Industries</a></li>
                                <li><a href="#use-cases" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-use-cases'); }}>EIE in Action</a></li>
                                <li><a href="#case-studies" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-case-studies'); }}>Case Studies</a></li>
                            </ul>
                        </div>
                        
                        <div className="footer-column">
                            <h4>EIE Solutions</h4>
                            <ul>
                                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-services'); }}>Content Intelligence</a></li>
                                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-services'); }}>Neural Knowledge Graph</a></li>
                                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-services'); }}>Real-Time User Profiling</a></li>
                                <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('.redesign-services'); }}>Intelligent Adaptation</a></li>
                            </ul>
                        </div>
                        
                        <div className="footer-column">
                            <h4>Contact Us</h4>
                            <div className="contact-info">
                                <div className="contact-item">
                                    <span>info@alphacogs.co.uk</span>
                                </div>
                                <div className="contact-item">
                                    <span>Alpha Cogs Ltd<br />London, United Kingdom</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="footer-bottom">
                    <p>Copyright 2026,  Alpha Cogs Ltd. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;